import { Event } from '../types';
import StatusBadge from './StatusBadge';

type EventDetailsGridProps = {
  event: Event;
  showStatus?: boolean;
  showResponsibility?: boolean;
  onRegistrationClick?: () => void;
};

const formatLabels: Record<Event['format'], string> = {
  presencial: 'Presencial',
  online: 'Online',
  hibrido: 'Híbrido',
};

const accessLabels: Record<Event['accessType'], string> = {
  aberto: 'Aberto',
  ingressos: 'Venda de ingressos',
};

const EventDetailsGrid = ({
  event,
  showStatus = false,
  showResponsibility = false,
  onRegistrationClick,
}: EventDetailsGridProps) => {
  const items = [
    { label: 'Início', value: new Date(event.startAt).toLocaleString('pt-BR') },
    { label: 'Término', value: new Date(event.endAt).toLocaleString('pt-BR') },
    { label: 'Local', value: event.location },
    { label: 'Instituição', value: event.institution },
    { label: 'Promotor', value: event.promoter },
    { label: 'Formato', value: formatLabels[event.format] },
    { label: 'Público', value: event.targetAudience },
    { label: 'Estimativa', value: event.estimatedAudience ? String(event.estimatedAudience) : 'Não informada' },
    { label: 'Acesso', value: accessLabels[event.accessType] },
  ];

  return (
    <div className="event-details-grid">
      {showStatus && (
        <div className="metric-card">
          <span>Status</span>
          <strong>
            <StatusBadge kind="event" status={event.status} />
          </strong>
        </div>
      )}
      {items.map((item) => (
        <div className="metric-card" key={item.label}>
          <span>{item.label}</span>
          <strong>{item.value}</strong>
        </div>
      ))}
      {event.registrationLink && (
        <div className="metric-card">
                  <span>Inscrição</span>
                  <strong>
                    <a
                      href={event.registrationLink}
                      target="_blank"
                      rel="noreferrer"
                      onClick={onRegistrationClick}
                    >
                      Abrir link
                    </a>
          </strong>
        </div>
      )}
      <div className="metric-card">
        <span>Descrição</span>
        <strong>{event.descriptionFormat === 'html' ? 'HTML seguro' : 'Texto simples'}</strong>
      </div>
      {showResponsibility && (
        <div className="metric-card">
          <span>Responsabilidade</span>
          <strong>{event.responsibilityAccepted ? 'Aceita' : 'Pendente'}</strong>
        </div>
      )}
    </div>
  );
};

export default EventDetailsGrid;
